export default __webpack_public_path__ + "static/media/lime.92137fc5.svg";